import { render, staticRenderFns } from "./TaxReporting.vue?vue&type=template&id=28dd12e5&scoped=true&lang=pug"
import script from "./TaxReporting.vue?vue&type=script&lang=ts"
export * from "./TaxReporting.vue?vue&type=script&lang=ts"
import style0 from "./TaxReporting.vue?vue&type=style&index=0&id=28dd12e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd12e5",
  null
  
)

export default component.exports